import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: '#1a1a2e',
      color: '#ffffff',
      padding: '60px 0 30px',
      marginTop: '0px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        <div style={{
          display: 'grid',
          gridTemplateColumns: window.innerWidth <= 768 ? '1fr' : 'repeat(3, 1fr)',
          gap: '40px',
          marginBottom: '40px'
        }}>
          
          {/* First Column */}
          <div style={{
            textAlign: window.innerWidth <= 768 ? 'center' : 'left'
          }}>
            <h3 style={{
              fontSize: '1.8rem',
              fontWeight: '700',
              marginBottom: '15px',
              color: '#00b4d8'
            }}>
              Nawrasama
            </h3>
            <p style={{
              fontSize: '1.1rem',
              marginBottom: '10px',
              color: '#e0e0e0',
              fontWeight: '500'
            }}>
              Computer Science Undergraduate
            </p>
            <p style={{
              fontSize: '1rem',
              lineHeight: '1.6',
              color: '#b0b0b0'
            }}>
              Strong foundation in software development and a passion for
              building efficient, user-focused applications.
            </p>
          </div>
          
          {/* Second Column - Contact Info */}
          <div style={{
            textAlign: window.innerWidth <= 768 ? 'center' : 'left'
          }}>
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#00b4d8'
            }}>
              Contact Info
            </h3>
            <p style={{
              fontSize: '1.1rem',
              marginBottom: '15px',
              color: '#e0e0e0'
            }}>
              <strong style={{ color: '#00b4d8' }}>Email:</strong> mail2samasama@gmail.com
            </p>
            <div style={{
              display: 'flex',
              gap: '15px',
              justifyContent: window.innerWidth <= 768 ? 'center' : 'flex-start',
              flexWrap: 'wrap'
            }}>
              <a 
                href="https://github.com/nawrasama" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  padding: '10px 25px',
                  backgroundColor: '#333',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#00b4d8';
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(0, 180, 216, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#333';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.012 8.012 0 0 0 16 8c0-4.42-3.58-8-8-8z"/>
                </svg>
                GitHub
              </a>
              <a 
                href="https://www.linkedin.com/in/nawra-sama-b964142bb/" 
                target="_blank" 
                rel="noopener noreferrer"
                style={{
                  padding: '10px 25px',
                  backgroundColor: '#0077b5',
                  color: 'white',
                  textDecoration: 'none',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#005582';
                  e.target.style.transform = 'translateY(-3px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(0, 117, 181, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#0077b5';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                  <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>
                </svg>
                LinkedIn
              </a>
            </div>
          </div>
          
          {/* Third Column - Quick Links */}
          <div style={{
            textAlign: window.innerWidth <= 768 ? 'center' : 'left'
          }}>
            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '600',
              marginBottom: '20px',
              color: '#00b4d8'
            }}>
              Quick Links
            </h3>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px'
            }}>
              <a 
                href="#home" 
                style={{
                  fontSize: '1.1rem',
                  color: '#e0e0e0',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#00b4d8';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#e0e0e0';
                  e.target.style.transform = 'translateX(0)';
                }}
              >
                Home
              </a>
              <a 
                href="#projects" 
                style={{
                  fontSize: '1.1rem',
                  color: '#e0e0e0',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#00b4d8';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#e0e0e0';
                  e.target.style.transform = 'translateX(0)';
                }}
              >
                Projects
              </a>
              <a 
                href="#contact" 
                style={{
                  fontSize: '1.1rem',
                  color: '#e0e0e0',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  fontWeight: '500'
                }}
                onMouseEnter={(e) => {
                  e.target.style.color = '#00b4d8';
                  e.target.style.transform = 'translateX(5px)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.color = '#e0e0e0';
                  e.target.style.transform = 'translateX(0)';
                }}
              >
                Contact
              </a>
            </div>
          </div>
        </div>
        
        {/* Footer Bottom */}
        <div style={{
          borderTop: '1px solid rgba(255, 255, 255, 0.1)',
          paddingTop: '30px',
          textAlign: 'center'
        }}>
          <p style={{
            fontSize: '1rem',
            color: '#b0b0b0',
            marginBottom: '10px'
          }}>
            © 2025 Nawrasama. All rights reserved.
          </p>
          <p style={{
            fontSize: '1rem',
            color: '#00b4d8',
            fontWeight: '600'
          }}>
            Designed & Developed by Nawrasama
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;